import { List, ListItem } from '@mui/material';
import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { Button } from '../button/button';

type IAccountAgreements = {
  id: string;
  url: string;
};

export const AccountAgreements = ({
  label,
  value,
}: {
  label: string;
  value: any;
  key?: string;
}) => (
  <Box>
    <Typography variant='bodyLarge'>{label}</Typography>
    <List>
      {(value.agreements ?? []).map(({ id, url }: IAccountAgreements) => (
        <ListItem key={id}>
          <Button
            label={url.split('/').pop() ?? ''}
            variant='outlined'
            size='sm'
            href={url}
            target='_blank'
          />
        </ListItem>
      ))}
    </List>
  </Box>
);
